<section class="app2 team-section p-t-0">
  <div class="container">
    <div class="row d-flex justify-content-center">
      @defer(on idle){
      <div class="col-md-10 offset-md-1 m-0">
        <div class="title title2">
          <img src="" alt="" class="img-fluid title-img">
          <p class="font-primary borders main-text"><span></span></p>
          <div class="sub-title">
            <h2 class="title-text text-center">
              {{mainText}}
            </h2>
          </div>
        </div>
        <p class="text-center mb-4 font-secondary">{{subTitle}}</p>
      </div>
      @for (user of users; track $index) {
      <div class="col-md-4 col-sm-6 text-center teams">
        <div class="our-team ">
          <div class=" set-relative ">
            <div class="border-around overflow-hide m-auto">
              <div class="set-relative overflow-hide">
                <img [src]="user.teamImage.data.attributes.url" [alt]="user.teamImage.data.attributes.alternativeText"
                  class="img-fluid team">
                <div class="overlay-team set-abs">
                  @if (teamsHoverImage) {
                  <img [src]="teamsHoverImage" alt="" class="img-fluid wave">
                  }
                </div>
              </div>
            </div>
          </div>
          <div class="set-relative set-border">
            <div class="set-abs top-0 borders"></div>
          </div>
          <div class="employee">
            <p class="e-name text-center fs-5">{{user.name}}</p>
            <p class="post text-center ">{{user.designation}}</p>
          </div>
        </div>
      </div>
      }
      }@placeholder{
      <div class="col-md-10 offset-md-1 m-0">
        <div class="title title2">
          <img src="" alt="" class="img-fluid title-img">
          <p class="font-primary borders main-text"><span></span></p>
          <div class="sub-title">
            <h2 class="title-text text-center">
              <ngx-skeleton-loader />
            </h2>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-sm-6 text-center teams">
        <div class="our-team ">
          <div class=" set-relative ">
            <div class="border-around overflow-hide m-auto">
              <div class="set-relative overflow-hide">
                <ngx-skeleton-loader appearance="circle" [theme]="{width:'15.625rem',height:'15.625rem'}" />
                <div class="overlay-team set-abs">
                  <img [src]="teamsHoverImage" alt="" class="img-fluid wave">
                </div>
              </div>
            </div>
          </div>
          <div class="set-relative set-border">
            <div class="set-abs top-0 borders"></div>
          </div>
          <div class="employee">
            <ngx-skeleton-loader />
          </div>
        </div>
      </div>
      }
    </div>
  </div>
</section>
